import { Colors as BaseColors, TagColor } from '@factorialco/deprecated-design-system'
import {
  FinanceValueObjectsAllocationStatusEnum,
  FinanceValueObjectsBudgetStatusEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const budgetTagColor = (status: FinanceValueObjectsBudgetStatusEnum) => {
  const TAG_COLORS: Record<FinanceValueObjectsBudgetStatusEnum, TagColor> = {
    within_budget: TagColor.viridian,
    budget_risk: TagColor.tangerine,
    over_budget: TagColor.radical,
  }

  return TAG_COLORS[status]
}

export const budgetStatusText = (status: FinanceValueObjectsBudgetStatusEnum) => {
  const tagStatus: Record<FinanceValueObjectsBudgetStatusEnum, string> = {
    within_budget: i18n.t('budgets.status.within_budget'),
    budget_risk: i18n.t('budgets.status.budget_risk'),
    over_budget: i18n.t('budgets.status.over_budget'),
  }

  return tagStatus[status]
}

export const allocationStatusText = (status: FinanceValueObjectsAllocationStatusEnum) => {
  const tagStatus: Record<FinanceValueObjectsAllocationStatusEnum, string> = {
    within_allocation: i18n.t('budgets.allocation_status.within_allocation'),
    allocation_risk: i18n.t('budgets.allocation_status.allocation_risk'),
    over_allocation: i18n.t('budgets.allocation_status.over_allocation'),
  }

  return tagStatus[status]
}

export const allocationTagColor = (status: FinanceValueObjectsAllocationStatusEnum) => {
  const ALLOCATION_TAG_COLORS: Record<FinanceValueObjectsAllocationStatusEnum, TagColor> = {
    within_allocation: TagColor.viridian,
    allocation_risk: TagColor.tangerine,
    over_allocation: TagColor.radical,
  }

  return ALLOCATION_TAG_COLORS[status]
}

export const allocationStatusColor = (status: FinanceValueObjectsAllocationStatusEnum) => {
  const ALLOCATION_STATUS_COLORS: Record<FinanceValueObjectsAllocationStatusEnum, BaseColors> = {
    within_allocation: 'viridian1000',
    allocation_risk: 'champagne1000',
    over_allocation: 'radicalRed1000',
  }

  return ALLOCATION_STATUS_COLORS[status]
}
